import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <section className="footer">
        <div className="container-5">
          <div className="footer-wrapper-two">
            <div className="div-block-29">
              <div className="div-block-30 _2-cells">
                <div className="footer-type-block footer-type-block-right-pad">
                  <div>
                    <div text-animation className="footer-title">
                      Looking for
                    </div>
                  </div>
                  <div className="div-block-35">
                    <Link
                      text-animation
                      to="/"
                      aria-current="page"
                      className="footer-link-two w--current"
                    >
                      Home
                    </Link>
                    <Link
                      text-animation
                      to="/about-us"
                      className="footer-link-two"
                    >
                      About Us
                    </Link>
                    <Link
                      text-animation
                      to="/gallery"
                      className="footer-link-two"
                    >
                      Gallery
                    </Link>
                    <Link
                      text-animation
                      to="/contactus"
                      className="footer-link-two"
                    >
                      Contact Us
                    </Link>
                  </div>
                </div>
                <div className="footer-type-block">
                  <div>
                    <div text-animation className="footer-title">
                      Customer Service
                    </div>
                  </div>
                  <div className="div-block-36">
                    <Link
                      text-animation
                      to="tel:+917339967115"
                      target="_blank"
                      className="footer-link-two"
                    >
                      +91-7339967115
                    </Link>
                    <Link
                      text-animation
                      to="tel:+917023894408"
                      target="_blank"
                      className="footer-link-two"
                    >
                      +91-7023894408
                    </Link>
                    <Link
                      text-animation
                      to="mailto:mrgmultisportsclub@gmail.com"
                      target="_blank"
                      className="footer-link-two"
                    >
                      mrgmultisportsclub@gmail.com
                    </Link>
                  </div>
                </div>
              </div>
              <div className="div-block-31">
                <div className="footer-type-block">
                  <div>
                    <div text-animation className="footer-title">
                      Social Media
                    </div>
                  </div>
                  <div className="div-block-37">
                    <Link
                      text-animation
                      to="https://www.facebook.com/godara146?mibextid=2JQ9oc"
                      target="_blank"
                      className="footer-link-two"
                    >
                      Facebook
                    </Link>
                    <Link
                      text-animation
                      target="_blank"
                      to="https://wa.me/+917023894408"
                      className="footer-link-two"
                    >
                      Whatsapp
                    </Link>
                    <Link
                      text-animation
                      to="https://www.instagram.com/mrg_multisportsclub"
                      className="footer-link-two"
                      target="_blank"
                    >
                      Instagram
                    </Link>
                  </div>
                </div>
                <div el-animation className="footer-social-block-two"></div>
              </div>
            </div>
          </div>
          <div el-animation className="footer-bottom">
            <div className="div-block-38">
              <div className="div-block-39">
                <Link
                  to="/"
                  aria-current="page"
                  className="footer-brand w-inline-block w--current"
                >
                  <img
                    src="./assets/images/logo_03.png"
                    loading="lazy"
                    width={118}
                    alt
                    className="image-15 logo-footer"
                  />
                </Link>
                <div className="footer-copyright">
                  <strong>©</strong> 2025 MRG MultiSports Club
                </div>
              </div>
              <Link
                to="https://nspacesolution.com"
                target="_blank"
                className="gladkov-link w-inline-block"
              >
                <div className="gladkov-link-text">
                  design and development by
                </div>
                <img
                  src="https://cdn.prod.website-files.com/64899c647bc07ddd2ccf0cef/64899c647bc07ddd2ccf0da9_Logo-gladkov.svg"
                  loading="lazy"
                  alt
                  className="image-25"
                />
              </Link>
            </div>
            <div className="footer-social-block-two visible_mob">
              <a
                href="https://www.instagram.com/mrg_multisportsclub"
                className="footer-social-link w-inline-block"
                target="_blank"
              >
                <img
                  src="https://cdn.prod.website-files.com/64899c647bc07ddd2ccf0cef/64899c647bc07ddd2ccf0d6a_Instagram%20icon.svg"
                  loading="lazy"
                  alt
                  className="social-image"
                />
              </a>
              <a
                href="https://www.facebook.com/godara146?mibextid=2JQ9oc"
                className="footer-social-link w-inline-block"
                target="_blank"
              >
                <img
                  src="https://cdn.prod.website-files.com/64899c647bc07ddd2ccf0cef/64899c647bc07ddd2ccf0d8a_facebook%20icon.svg"
                  loading="lazy"
                  alt
                  className="image-9 social-image"
                />
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Footer;
